// extracted by mini-css-extract-plugin
export default {"motionPath":"SvgAnimationLogo_motionPath__yJyUP"};